import { Injectable, inject } from "@angular/core";
import { AppConsts } from "@shared/AppConsts";
import { LocalizationService } from "abp-ng2-module";

export interface ITranslateService {
    l(key: string, ...args: unknown[]): string;
}

@Injectable({
    providedIn: "root",
})
export class TranslationService {
    localizationSourceName = AppConsts.localization.defaultLocalizationSourceName;
    localization = inject(LocalizationService);

    readonly l = (key: string, ...args: unknown[]): string => {
        let localizedText = this.localization.localize(key, this.localizationSourceName);

        if (!localizedText) {
            localizedText = key;
        }

        if (!args || !args.length) {
            return localizedText;
        }

        args.unshift(localizedText);
        return abp.utils.formatString.apply(this, args);
    };
}
